export default "__VITE_ASSET__C6c3W45K__"